<template>
    <div>
        <input :value="localDate"
               type="date"
               ref="dateInput"/>
        <input :value="localTime"
               type="time"
               step="0.001"
               ref="timeInput"/>
    </div>
</template>

<script>
	require('time-input-polyfill/auto')
	export default {
		name: "DatePicker",
		props: {
			data: {
				required: true
			}
		},
        computed: {
			localDate() {
				let date = new Date(this.data);
				return `${date.getFullYear()}-${this.padLeft(date.getMonth() + 1)}-${this.padLeft(date.getDate())}`
            },
			localTime() {
				let date = new Date(this.data);
				let timeString = date.toTimeString();
				return timeString.substring(0, timeString.indexOf(" ")) + "." + date.getMilliseconds();
            }
        },
		methods: {
			getValue() {
				return new Date(this.$refs.dateInput.value + " " +
					this.$refs.timeInput.value).toISOString();
			},
            padLeft(x) {
				return x < 10 ? "0" + String(x) : String(x);
            }
		}
	}
</script>

<style scoped>

</style>